import React, { Component } from 'react';
import { adjustmentsShape } from '../../../utils/propTypes';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import './AdjustmentsListItem.scss';
import { prettifyDate } from '../../../utils/string';

export default class AdjustmentsListItem extends Component {
    static propTypes = {
        item: adjustmentsShape.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderMerchant(merchantName) {
        return merchantName ? merchantName : 'No Merchant';
    }

    renderDescriptor(descriptor) {
        return descriptor ? descriptor : 'No Descriptor';
    }

    render() {
        const adjustments = this.props.item;

        return (
            <div className="adjustments-list-item">
                <div className="adjustments-list-item-left">
                    <span className="adjustments-date">
                        {this.renderDate(adjustments.transactionDate)}
                    </span>
                    <span className="adjustments-merchant">
                        {this.renderMerchant(adjustments.merchantName)}
                    </span>
                </div>
                <div className="adjustments-list-item-right">
                    <span className="adjustments-amount">
                        <ColorDollarAmountCell amount={adjustments.netAmount}/>
                    </span>
                    <span className="adjustments-descriptor">
                        {this.renderDescriptor(adjustments.lockBoxBatch)}
                    </span>
                </div>
            </div>
        );
    }
}
